module.exports = __webpack_public_path__ + "img/QH.027853d3.svg";